const defaultState = {
  grade: "",
  level: "",
  to_date: "",
  institute: "",
  from_date: "",
  scholarity: "",
  certificate: "",
  popupActive: false
};

export default {
  CLEAR_FORMATION_STATE: state =>
    (state.formation = Object.assign({}, { ...defaultState })),

  index: (state, payload) => {
    state.formations = [...payload];
  },

  store: (state, payload) => {
    let _formations = [...state.formations];
    _formations = [..._formations, { ...payload }];

    state.formations = _formations;
  },

  update: (state, payload) => {
    let _formations = [...state.formations];

    const index = _formations.findIndex(
      formation => formation.id == payload.id
    );

    _formations[index] = payload;

    state.formations = _formations;
  },

  delete: (state, payload) => {
    let _formations = [...state.formations];
    _formations = _formations.filter(formation => formation.id != payload.id);

    state.formations = _formations;
  }
};
